<template>
    <div>
        <!--调拨详情-->
        <Card :bordered="false" dis-hover>
            <p slot="title">详情</p>
            <Row>
                <Col span="8"><strong>客户：</strong><span class="result">{{pageData.customer.name}}</span></Col>
                <Col span="8"><strong>商品金额：</strong> <span class="result">￥{{pageData.totalmoney}}</span></Col>
                <Col span="8"  v-if="isroule"><strong>成本：</strong> <span class="result">{{pageData.totalmoney-pageData.grossProfit}}</span></Col>
                <Col span="8"><strong>销售员：</strong> <span class="result">{{pageData.adminName}}</span></Col>
                <Col span="8"><strong>商品数量：</strong> <span class="result">{{pageData.total }}</span></Col>
                <Col span="8"  v-if="isroule"><strong>毛利：</strong> <span class="result">{{pageData.grossProfit}}</span></Col>
                <Col span="8"><strong>制单人：</strong> <span class="result">{{pageData.adminName}}</span></Col>
                <Col span="8"><strong>实收金额：</strong> <span class="result">{{pageData.paymoney}}</span></Col>
                <Col span="8"  v-if="isroule"><strong>毛利率：</strong>
                    <span class="result">{{pageData.rateOfMargin}} &nbsp;</span>
                </Col>
                <Col span="8"><strong>单据编号：</strong> <span class="result">{{pageData.markcode}}</span></Col>
                <Col span="8"><strong>结算账户：</strong>
                    <span style="margin-right: 5px" class="result" v-for="(k,v) in pageData.bankmarket" :key="v">{{k.bankname}}  (￥{{k.money}})</span>
                </Col>
                <Col span="8"><strong>创建时间：</strong> <span class="result">{{pageData.time}}</span></Col>
               <!-- <Col span="8"><strong>优惠金额：</strong> <span class="result">{{pageData.discountsmoney}}</span></Col>
                <Col span="8"><strong>抹零金额：</strong> <span class="result">{{pageData.removemoney}}</span></Col>
                <Col span="8"><strong>本单欠款：</strong> <span class="result">{{pageData.nomoney}}</span></Col>-->
            </Row>
        </Card>

            <table slot="content" class="ive-table" v-for="(item, index) in pageData.goodslist" :key="index">
                <thead>
                <th>商品详情</th>
                <th>名称/货号</th>
                <th>规格/颜色</th>
                <th>单价</th>
                <th>数量</th>
                </thead>
                <tbody>
                <tr align="center" v-for="(k,v) in pageData.goodslist[index].goodsItem" :key = v>
                    <td width="200" :rowspan="v" v-if="v==0">
                        <Fy-Img
                                :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                :Width="100"
                                :Height="100"
                        ></Fy-Img>
                    </td>
                    <td>{{item.goodsname}} / {{item.goodscode}}</td>
                    <td>{{k.size}} / {{k.color}}</td>
                    <td>{{k.lprice}}</td>
                    <td>{{k.quantity}}</td>
                </tr>

                </tbody>
            </table>
        </div>

</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pageData:{},
                username:'',
                bankname:'',
                isroule:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.pageData = JSON.parse(sessionStorage.getItem('particularDetail'))
            this.getMarketId(this.pageData.id);
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('94')){
                this.isroule=false
            }
        },

        methods: {
            //获取销售单单
            getMarketId(id){
                this.$Api.getMarketId({
                    id:id
                }).then(res => {
                    if(res.code==200){
                        this.pageData.goodslist = res.data.goodslist;
                        this.pageData.grossProfit = res.data.grossProfit;
                        this.pageData.rateOfMargin = res.data.rateOfMargin;
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },            
            //获取采购单
           /* getMarketId(id){
                this.$Api.getMarketId({
                    id:id
                }).then(res => {
                    if(res.code==200){
                         this.pageData = res.data
                         this.username = res.data.customer.name
                         this.bankmarket = res.data.bankmarket[0].bankmarket
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },*/
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>